import { render } from "./BottomNavigation.vue?vue&type=template&id=03bebf7c&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=03bebf7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03bebf7c"

export default script